/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 * Constants for Banner component
 *
 * @author Yakov Gushchin
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Ilya Baranchikov
 * @author Nikolay Sviridov
 * @version 1.33.0
 * @since 1.0.0
 */

import { IBannerItem } from '@nexign/scc-ui-kit/lib/components/Banner/types';

import { bannerDefaultDesktop } from '@/main/theme/default/icons';

export const MAX_BANNERS_SHOW_COUNT = 7;
export const INTERVAL_FOR_SLIDER = 5000;

/*
 * -------------------------------------------
 *           LOAD BANNER
 * -------------------------------------------
 */

export const LOAD_BANNER = '@@b2b_portal_ui/banner/LOAD_BANNER';
export const LOAD_BANNER_SUCCESSFUL = '@@b2b_portal_ui/banner/LOAD_BANNER_SUCCESSFUL';
export const LOAD_BANNER_FAILED = '@@b2b_portal_ui/banner/LOAD_BANNER_FAILED';

/*
 * -------------------------------------------
 *       HIDE BANNER CAMPAIGN
 * -------------------------------------------
 */

export const HIDE_BANNER = '@@b2b_portal_ui/banner/HIDE_BANNER';
export const HIDE_BANNER_SUCCESSFUL = '@@b2b_portal_ui/banner/HIDE_BANNER_SUCCESSFUL';
export const HIDE_BANNER_ERROR = '@@b2b_portal_ui/banner/HIDE_BANNER_ERROR';

/*
 * -------------------------------------------
 *       HIDE ALTERNATIVE BANNER CAMPAIGN
 * -------------------------------------------
 */

export const HIDE_ALTERNATIVE_BANNER = '@@b2b_portal_ui/banner/HIDE_ALTERNATIVE_BANNER';
export const HIDE_ALTERNATIVE_BANNER_SUCCESSFUL = '@@b2b_portal_ui/banner/HIDE_ALTERNATIVE_BANNER_SUCCESSFUL';
export const HIDE_ALTERNATIVE_BANNER_ERROR = '@@b2b_portal_ui/banner/HIDE_ALTERNATIVE_BANNER_ERROR';

/*
 * -------------------------------------------
 *       REGISTRATION ALTERNATIVE BANNER
 * -------------------------------------------
 */

export const REGISTRATION_CLICK_ALTERNATIVE_BANNER = '@@b2b_portal_ui/banner/REGISTRATION_CLICK_ALTERNATIVE_BANNER';
export const REGISTRATION_SHOW_ALTERNATIVE_BANNER = '@@b2b_portal_ui/banner/REGISTRATION_SHOW_ALTERNATIVE_BANNER';
export const REGISTRATION_ALTERNATIVE_BANNER_FAILURE = '@@b2b_portal_ui/banner/REGISTRATION_ALTERNATIVE_BANNER_FAILURE';

/*
 * -------------------------------------------
 *       DEFAULT BANNER
 * -------------------------------------------
 */

export const defaultBanner: IBannerItem = {
    id: 0,
    imageURL: bannerDefaultDesktop,
};
